import { render, staticRenderFns } from "./instances-grid.component.vue?vue&type=template&id=27b66c7b&scoped=true"
import script from "./instances-grid.component.vue?vue&type=script&lang=ts"
export * from "./instances-grid.component.vue?vue&type=script&lang=ts"
import style0 from "./instances-grid.component.vue?vue&type=style&index=0&id=27b66c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b66c7b",
  null
  
)

export default component.exports